import React from 'react';
import MarketplaceSection from './MarketplaceSection';
import { useMemoryContentCardCategories } from 'hooks/memory';

function MarketplaceTabContent() {
  const { memoryContentCardCategories } = useMemoryContentCardCategories();

  return (
    <>
      {memoryContentCardCategories?.map((contentCard) => (
        <MarketplaceSection contentCard={contentCard} key={contentCard.id} />
      ))}
    </>
  );
}

export default MarketplaceTabContent;
